// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Listen';

interface ListenProps {
  className?: string;
}

export function Listen({ className }: ListenProps) {
  return (
    <svg
      className={className}
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={TITLE}
      role="img"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.10853C4.25623 1.10853 1.17073 4.03239 1.17073 7.69757V13.04H0V7.69757C0 3.49459 3.55379 0.0400391 8 0.0400391C12.4462 0.0400391 16 3.49459 16 7.69757V13.04H14.8293V7.69757C14.8293 4.03239 11.7438 1.10853 8 1.10853Z"
        fill="currentColor"
      />
      <rect y="8" width="2.5" height="5" fill="currentColor" />
      <rect x="13.5" y="8" width="2.5" height="5" fill="currentColor" />
      <path d="M6 13.96V7.95996L11 10.96L6 13.96Z" fill="currentColor" />
    </svg>
  );
}
